import React, { useEffect, useRef, useState } from 'react';
import '../assets/css/custom.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/steps.css';
import '../assets/css/Resident.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faChevronLeft, faEdit, faMotorcycle, faPlus, faTrash, faTag } from '@fortawesome/free-solid-svg-icons';
import clientlogo from '../assets/img/user1.png';
import FemaleIcon from '../assets/img/FemaleIcon.png';
import TransgenderIcon from '../assets/img/TransgenderIcon.png';
import oldy from '../assets/img/oldy.png';
import FemaleImage from '../assets/img/FemaleImage.png';
import TransgenderImage from '../assets/img/TransgenderImage.png';
import car from '../assets/img/car.png';
import Bike from '../assets/img/bike.png';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Menus from "./menus";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import socialbg from '../assets/img/socialbg.jpg';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import cbadd from '../assets/img/cbadd.jpg'
import family from '../assets/img/family.jpg'
import { commonAPI } from "../services/CommonAPIService"
import { ErrorSource } from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import { Offline, Online } from "react-detect-offline";
import NoInternet from "./Nointernet";
import 'react-toastify/dist/ReactToastify.css';
import { Table } from 'react-bootstrap';

function Familydetails(props) {
    const history = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [filterRfId,setFilterForRFID] = useState()
    const [tagId,setTagIdModal] = useState(false)
    const steps = ['Step 1', 'Step 2', 'Step 3'];
    const [show, setShow] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [showVehicle, setShowVehicle] = useState(false);
    const [ClientName, setClientName] = useState("");
    const [UserName, setUserName] = useState("");
    const [MobileNumber, setMobileNumber] = useState("");
    const [Email, setEmail] = useState("");
    const [SpocName, setSpocName] = useState("");
    const [selectedImageTwo, setSelectedImageTwo] = useState(null)
    const [selectedImageThree, setSelectedImageThree] = useState(null)
    const [selectedImageFour, setSelectedImageFour] = useState(null)
    const [FamilyList, setFamilyList] = useState()
    const [VehicleList, setVehicleList] = useState()
    const [Gender, setGender] = useState("")
    const [TagSerialNumberDisplay,setTagSerialNumberDisplay] = useState()
    const [TagIdShow,setTagIdShow] = useState("")
    const [VehicleNumber, setVehicleNumber] = useState()
    const [VehicleId, setVehicleId] = useState()
    const [TagId, setTagId] = useState()
    const [VehicleType, setVehicleType] = useState("4WHEELER")
    const [FamilyGroupId, setFamilyGroupId] = useState()
    const [FlatId, setFlatId] = useState()
    const [OwnerName, setOwnerName] = useState()
    const [SecurityLock, setSecurityLock] = useState()
    const [FuelList, setFuelList] = useState()
    const [FuelType, setFuelType] = useState()
    const [BrandList, setBrandList] = useState()
    const [BrandListUpdate, setBrandListUpdate] = useState()
    const [SearchBrand, setSearchBrand] = useState()
    const [BrandSelect, setBrandSelect] = useState()
    const [ShowUpdateBtn, setShowUpdateBtn] = useState(false)
    const [DeleteShow, setDeleteShow] = useState(false);
    const [VehicleTypeBtnBike, setVehicleTypeBtnBike] = useState(false);
    const [VehicleTypeBtnCar, setVehicleTypeBtnCar] = useState(true);
    const [showBrand, setShowBrand] = useState(false);
    const [ResidentShow, setResidentShow] = useState(false);
    const [PrimaryUser, setPrimaryUser] = useState("");
    const [UserData, setUserData] = useState("");
    const [UserMappingId, setUserMappingId] = useState("");
    const [UserChildId, setUserChildId] = useState("");
    const [ParentList, setParentList] = useState("");
    const [ChildUpdate, setChildUpdate] = useState(false);
    const [FamilyGroupIdDelete, setFamilyGroupIdDelete] = useState("");
    const [ChildDeleteModal, setChildDeleteModal] = useState(false);
    const [ChildIsParent, setChildIsParent] = useState("");
    const [DeleteShowOne, setDeleteShowOne] = useState(false);
    const [rfTagIdList,setRFIDTagData] = useState(false)
    const [primaryInfo,setPrimaryInfo] = useState()
    const [usertagId,setUserTagIdModal] = useState(false)
    const [usertagModal,setUserTagModal] = useState(false)
    const [IsMappedTag,setIsMappedTag] = useState(false)
    const [modalHeading,setModalHeading] = useState("Add Vehicle Details")
    const [dataForReturn, setKeyForReturn] = useState()
    const [UserTagList, setUserTagList] = useState([])
    const [SearchUserTagList, setSearchUserTagList] = useState([])
    const [UserTagId, setUserTagId] = useState()
    const [SecretCode, setSecretCode] = useState()
    const [UserIdTag, setUserIdTag] = useState()
    const [FastagEndPoint, setFastagEndPoint] = useState()
    const [ShowResidentSetting, setResidentFastagSetting] = useState()
    const [FastagValue, setFastagValue] = useState([])
    const [FastagMap, setFastagMap] = useState("")
    const [EditFamily, setEditFamily] = useState(true)

    console.log("TagIdShow", TagIdShow)
    const location = useLocation();
    const data = location?.state
    console.log("dataparam", data)

    useEffect(() => {
        const storedUsername = localStorage.getItem('userData');
        const myUserData = JSON.parse(storedUsername);
        console.log("useEffect Local storage name", storedUsername)
        console.log("Role Name", myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin")
        if (storedUsername) {
          // If the username is present, redirect to the dashboard
          if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
            if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
                // if(data){
                    // history('/Familydetails');
                    return
                // }else{
                //     history('/Management');
                // }    
            }else{
              history('/Dashboard');
            }  
          }else{
            history('/Dashboard');
            console.log("useEffect Local storage Yes")
            return
          }  
        }
        else if (!storedUsername) {
          history('/');
          console.log("useEffect Local storage No")
        }
    }, [history]);

    const RFIDTagList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: `${VehicleType}/${false}`,
                buildingId: myUserData?.buildingId
            }
            let response = await commonAPI("RFIDTag", undefined, endPointVariableKey)
            setLoading(true);
            console.log("RFIDTagList response", response);
            if(response?.success == true && response?.message.length == 0){
                setRFIDTagData(response?.data)
                setFilterForRFID(response?.data)
                setLoading(false);
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }   
            
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Vehicle/RFIDTag",
                "errorNumber": "DC01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "ManageRFID.js",
                "functionName": "UploadSheet",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }   
    }

    const GetUserTagList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: `${IsMappedTag}`,
                buildingId: myUserData?.buildingId
            }
            let response = await commonAPI("UserTag", undefined, endPointVariableKey)
            setLoading(true);
            console.log("UserTag response", response, IsMappedTag);
            if(response?.success == true && response?.message.length == 0){
                setUserTagList(response?.data)
                setSearchUserTagList(response?.data)
                setLoading(false);
            }else{
                toast.error(response?.message[0]);
                setLoading(false);
            }   
            
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/UserTag",
                "errorNumber": "DC01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Familydetails.js",
                "functionName": "GetUserTagList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response); 
            setLoading(false);
            toast.error("Something went wrong");
            
        }   
    }

    useEffect(()=>{
        if (IsMappedTag !== undefined) {
            GetUserTagList();
        }
    }, [IsMappedTag]);

    const UpdateTagModal = (item) => {
        console.log("item UpdateTagModal", item);
        setUserTagId(item?.tagSerialNumber)
        if (UserTagList) {
            const selectedTag = UserTagList.find(tag => tag.tagSerialNumber === item?.tagSerialNumber);
            console.log("item selectedTag", selectedTag);
            if (selectedTag) {
                setSecretCode(selectedTag.secretCode);
            }
        }
        // setSecretCode(item?.secretCode)
        setUserTagModal(true)
        setUserIdTag(item?.userId)
    };

    const MapUserTag = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "modifiedUserId": myUserData?.userId?.toString(),
            "userId": UserIdTag,
            "tagSerialNumber": UserTagId,
            "secretCode": SecretCode,
        };
        try {
            if (!UserTagId) {
                toast.warning("Please select Tag Serial Number");
                setLoading(false);
            } else {
                console.log("bodyData", bodyData)
                setLoading(true);
                const endPointVariableKey = {
                    buildingId: myUserData.buildingId
                }
                let response = await commonAPI("MapUserTag", bodyData, endPointVariableKey);
                console.log("bodyDataresponse", response)
                if (response.success == true && response.message.length == 0) {
                    toast.success("Tag Mapped Successfully");
                    GetFamilyList();
                    GetParentList();
                    GetUserTagList();
                    setLoading(false);
                    setUserTagModal(false)
                } else {
                    toast.error(response.message[0]);
                    setLoading(false);
                }
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/ResidentVehicle",
                "errorNumber": "AV01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "AddVehicle",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    }
    

   
const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
    
    useEffect(()=>{
        RFIDTagList()
    },[VehicleType])


    const setInputValue = (item) => {
        console.log("item", item)
        setShowVehicle(true)
        RFIDTagList();
        setModalHeading("Update Vehicle Details")
        console.log("item", item)
        setShowUpdateBtn(true)
        setFamilyGroupId(item?.familyGroupId)
        setVehicleNumber(item?.lpNumber)
        setFuelType(item?.fuelType)
        setOwnerName(item?.ownerName)
        setTagIdModal(false)
        setSecurityLock(item?.securityLock)
        // setTagId(item?.tagId)
        setVehicleType(item?.vehicleType)
        setBrandSelect(item?.brand)
        setVehicleId(item?.vehicleId)
        setFlatId(item?.flatId)
        setTagIdShow(item?.tagId)
        setTagSerialNumberDisplay(item?.tagSerialNumber)
        setFastagMap(item?.fasTag)
        if (item?.vehicleType == "4WHEELER") {
            setVehicleTypeBtnCar(true)
            setVehicleTypeBtnBike(false)
        } else {
            setVehicleTypeBtnCar(false)
            setVehicleTypeBtnBike(true)
        }
    };

    const openCreateModal = () => {
        setShowVehicle(true)
        RFIDTagList();
        setShowUpdateBtn(false)
        setModalHeading("Add Vehicle Details")
        setFamilyGroupId("")
        setVehicleNumber("")
        setFuelType("")
        setOwnerName("")
        setSecurityLock("")
        setTagSerialNumberDisplay("")
        setTagIdModal(false)
        setTagId("")
        setTagIdShow("")
        setVehicleType("4WHEELER")
        setBrandSelect("")
        setVehicleId("")
        setVehicleTypeBtnCar(true)
        setVehicleTypeBtnBike(false)
    };

    const AddChildModal = () => {
        setShow(true);
        setEditFamily(false);
        setUserName("");
        setEmail("");
        setMobileNumber("");
        setChildUpdate(false);
        setUserChildId("");
        setGender("");
    };

    const UpdateChildModal = (item) => {
        console.log("item", item);
        setShow(true);
        setEditFamily(true);
        setUserName(item?.userName);
        setEmail(item?.emailId);
        setMobileNumber(item?.mobileNumber);
        setChildUpdate(true);
        setUserChildId(item?.userId);
        setGender(item?.gender);
    };

    const UpdateChildModal2 = () => {
        setEditFamily(true);
        setShow(true);
        setUserName(ParentList[0]?.userName);
        setEmail(ParentList[0]?.emailId);
        setMobileNumber(ParentList[0]?.mobileNumber);
        setChildUpdate(true);
        setUserChildId(ParentList[0]?.userId);
        setGender(ParentList[0]?.gender);
    };

    const UpdateParentModal = () => {
        console.log("item", ParentList[0]);
        setResidentShow(true);
        setUserName(ParentList[0]?.userName);
        setEmail(ParentList[0]?.emailId);
        setMobileNumber(ParentList[0]?.mobileNumber);
        setChildUpdate(true);
        setUserChildId(ParentList[0]?.userId);
        setGender(ParentList[0]?.gender);
    };

    const GetParentList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "buildingId": myUserData?.buildingId,
            "towerId": data?.[0]?.item?.towerId,
            "flatId": data?.[0]?.item?.flatId,
            "familyGroupId": data?.[0]?.familyGroupId,
            "isParent": true,
            "userImageRequired": true,
            "buildingLogoRequired": true,
            "maskedData": true
        }
        try {
            console.log("Parent Table bodyData", bodyData)
            let response = await commonAPI("GetCuroNextUserMapping", bodyData)
            setLoading(true);
            if (response?.success == true) {
                console.log("Parent Table List", response.data)
                setParentList(response?.data);
                // setParentUpdate("");
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/CuroNextUserFamily",
                "errorNumber": "GP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Family.js",
                "functionName": "GetParentList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetFamilyList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        const bodyData = {
            "buildingId": myUserData?.buildingId,
            "towerId": data?.[0]?.item?.towerId,
            "flatId": data?.[0]?.item?.flatId,
            "familyGroupId": data?.[0]?.familyGroupId,
            "isParent": false,
            "userImageRequired": true,
            "buildingLogoRequired": false,
            "maskedData": true
        }

        try {
            console.log("Family Table bodyData", bodyData)
            let response = await commonAPI("GetCuroNextUserMapping", bodyData)
            setLoading(true);
            if (response?.success == true) {
                console.log("Family Table", response)
                setFamilyList(response?.data);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/CuroNextUserFamily",
                "errorNumber": "RU01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "GetFamilyList.js",
                "functionName": "ResidentUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }


    const GetVehicleList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        const bodyData = { 
            "flatId":  data?.[0]?.item?.flatId,
            "familyGroupId": data?.[0]?.familyGroupId,
        };
        // console.log("Vehicle Table bodyData", bodyData)
        try {
            // const
            const endPointVariableKey = {
                // urlVariable: `${data?.[0]?.item?.flatId}/${data?.[0]?.familyGroupId}`,
                buildingId: myUserData?.buildingId

            }
            let response = await commonAPI("GetResidentVehicle", bodyData, endPointVariableKey)
            if (response?.success == true) {
                console.log("Vehicle Table", response)
                setVehicleList(response?.data);
            } else {
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/User/ResidentVehicle",
                "errorNumber": "RU01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Familydetails.js",
                "functionName": "GetVehicleList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    useEffect(() => {
        GetParentList();
        GetVehicleList();
        GetFamilyList();
    }, [])

    function toISTISOString(date) {
        // Get the current time in milliseconds since the Unix Epoch
        const currentTime = date.getTime();

        // IST offset is +5:30 (19800 seconds)
        const istOffset = 19800 * 1000; // Convert seconds to milliseconds

        // Create a new Date object with the adjusted time
        const istDate = new Date(currentTime + istOffset);

        // Format the date parts
        const pad = (num) => String(num).padStart(2, '0');
        const year = istDate.getUTCFullYear();
        const month = pad(istDate.getUTCMonth() + 1); // getUTCMonth is zero-indexed
        const day = pad(istDate.getUTCDate());
        const hours = pad(istDate.getUTCHours());
        const minutes = pad(istDate.getUTCMinutes());
        const seconds = pad(istDate.getUTCSeconds());
        const milliseconds = String((istDate.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5);

        // Construct the ISO string with the GMT+5:30 offset
        const istIsoString = `${year}-${month}-${day}T${hours}:${minutes}`;

        return istIsoString;
    }

    const ChildUser = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "createdUserId": myUserData?.userId?.toString(),
            "userName": UserName,
            "mobileNumber": MobileNumber,
            "termsAccepted": true,
            // "productAccessFactor": myUserData?.productAccessFactor,
            "emailId": Email,
        };
        try {
            setLoading(true);
            if (!UserName) {
                toast.warning("Please enter Name");
                setLoading(false);
            } else if (!MobileNumber) {
                toast.warning("Please enter Mobile Number");
                setLoading(false);
            }
            else if (MobileNumber.length != 10) {
                toast.warning("Please enter Valid Mobile Number");
                setLoading(false);
            }
            else if (!Gender) {
                toast.warning("Please select Gender");
                setLoading(false);
            }
            else {
                const endPointVariableKey = {
                    urlVariable: MobileNumber,
                }
                let responseLogin = await commonAPI("LoginGet", undefined, endPointVariableKey)
                console.log("responseLogin", responseLogin);
                if (responseLogin.message.length == 0) {
                    const bodyUserMapping = {
                        "createdUserId": myUserData?.userId.toString(),
                        "userId": responseLogin?.data?.userId,
                        "buildingId": myUserData?.buildingId,
                        // "buildingName": myUserData?.buildingName,
                        "towerId": data[0]?.item?.towerId,
                        "towerName": data[0]?.item?.towerName,
                        "flatId": data[0]?.item?.flatId,
                        "flatName": data[0]?.item?.flatName,
                        "roleName": data[0]?.item?.roleName,
                        "gender": Gender,
                        "isParent": false,
                        "currentStatus": "APPROVED",
                        "approverComment": null,
                        "approverUserName": myUserData?.userName,
                        "approvalDt": toISTISOString(new Date()),
                        "familyGroupId": data[0]?.item?.familyGroupId,
                        "loggedInUserRole": myUserData?.roleName,
                        "loggedInUserName": myUserData?.userName
                    };
                    console.log("body", bodyUserMapping);
                    let responseMapping = await commonAPI("CuroNextUserMappingAdd", bodyUserMapping)
                    console.log("responseMapping", responseMapping);
                    if (responseMapping?.success == true && responseMapping?.message.length == 0) {
                        toast.success("Family Member Added");
                        setShow(false);
                        setLoading(false);
                        GetFamilyList();
                    } else {
                        toast.error(responseLogin?.message[0]);
                        setLoading(false);
                    }
                } else {
                    console.log("body", bodydata);
                    let response = await commonAPI("User", bodydata)
                    setLoading(true);
                    console.log("responsebody", response);
                    if (response?.success == true && response?.message.length == 0) {
                        const bodyUserMapping = {
                            "createdUserId": myUserData?.userId.toString(),
                            "userId": response?.data?.userId,
                            "buildingId": myUserData?.buildingId,
                            // "buildingName": myUserData?.buildingName,
                            "towerId": data[0]?.item?.towerId,
                            "towerName": data[0]?.item?.towerName,
                            "flatId": data[0]?.item?.flatId,
                            "flatName": data[0]?.item?.flatName,
                            "roleName": data[0]?.item?.roleName,
                            "gender": Gender,
                            "isParent": false,
                            "currentStatus": "APPROVED",
                            "approverComment": null,
                            "approverUserName": myUserData?.userName,
                            "approvalDt": toISTISOString(new Date()),
                            "familyGroupId": data[0]?.item?.familyGroupId,
                            "loggedInUserRole": myUserData?.roleName,
                            "loggedInUserName": myUserData?.userName
                        };
                        console.log("body", bodyUserMapping);
                        let responseMapping = await commonAPI("CuroNextUserMappingAdd", bodyUserMapping)
                        console.log("responseMapping2", responseMapping);
                        if (responseMapping?.success == true && responseMapping?.message.length == 0) {
                            toast.success("Family Member Added");
                            setShow(false);
                            setLoading(false);
                            GetFamilyList();
                        } else {
                            toast.error(response?.message[0]);
                            setLoading(false);
                        }

                    } else {
                        toast.error(response?.message[0]);
                        setLoading(false);
                    }
                }


            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/User/User",
                "errorNumber": "RU01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Familydetails.js",
                "functionName": "ResidentUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }

    const UpdateChildUser = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "modifiedUserId": myUserData?.userId?.toString(),
            "userId": UserChildId,
            "userName": UserName,
            "mobileNumber": MobileNumber,
            "emailId": Email,
            "gender": Gender,
            "source": "PORTAL"
        };
        try {
            setLoading(true);
            if (!UserName) {
                toast.warning("Please enter Name");
                setLoading(false);
            } else if (!MobileNumber) {
                toast.warning("Please enter Mobile Number");
                setLoading(false);
            }
            else if (MobileNumber.length != 10) {
                toast.warning("Please enter Valid Mobile Number");
                setLoading(false);
            } else if (!Gender) {
                toast.warning("Please select Gender");
                setLoading(false);
            } else {
                console.log("body", bodydata);
                let response = await commonAPI("UserUpdate", bodydata)
                setLoading(true);
                console.log("responsebody", response);
                if (response.success == true && response.message.length == 0) {
                    toast.success("Family Member Updated");
                    setShow(false);
                    setLoading(false);
                    GetFamilyList();
                    GetParentList();
                } else {
                    toast.error(response.message[0]);
                    setLoading(false);
                }

            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/User/User",
                "errorNumber": "UC01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "UpdateChildUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }

    const UpdateResidentUser = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "modifiedUserId": myUserData?.userId?.toString(),
            "userId": UserChildId,
            "userName": UserName,
            "mobileNumber": MobileNumber,
            "emailId": Email,
            "gender": Gender
        };
        try {
            setLoading(true);
            if (!UserName) {
                toast.warning("Please enter Name");
                setLoading(false);
            } else if (!MobileNumber) {
                toast.warning("Please enter Mobile Number");
                setLoading(false);
            }
            else if (MobileNumber.length != 10) {
                toast.warning("Please enter Valid Mobile Number");
                setLoading(false);
            }else if (!Gender) {
                toast.warning("Please select Gender");
                setLoading(false);
            } else {
                console.log("body", bodydata);
                let response = await commonAPI("UserUpdate", bodydata)
                setLoading(true);
                console.log("responsebody", response);
                if (response.success == true && response.message.length == 0) {
                    toast.success("Family Member Updated");
                    setResidentShow(false);
                    setLoading(false);
                    GetParentList();
                } else {
                    toast.error(response.message[0]);
                    setLoading(false);
                }

            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/User/User",
                "errorNumber": "UC01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "UpdateChildUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }

    const DeleteUserModal = (item) => {
        console.log("item", item);
        setChildDeleteModal(true)
        setUserMappingId(item?.userMappingId)
        setFamilyGroupIdDelete(item?.familyGroupId);
        setChildIsParent(item?.isParent)
    }

    const DeleteParentModal = () => {
        // console.log("item", item);
        setChildDeleteModal(true)
        setUserMappingId(ParentList[0]?.userMappingId)
        setFamilyGroupIdDelete(ParentList[0]?.familyGroupId);
        setChildIsParent(ParentList[0]?.isParent)
    }

    const DeleteChildUser = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            "modifiedUserId": myUserData?.userId?.toString(),
            "familyGroupId": FamilyGroupIdDelete,
            "userMappingId": UserMappingId,
            "isParent": ChildIsParent,
        };
        try {
            setLoading(true);
            console.log("body", bodydata);
            let response = await commonAPI("DeleteUserOrFamily", bodydata)
            setLoading(true);
            console.log("responsebody", response);
            if (response.success == true && response.message.length == 0) {
                toast.success("Family Member Deleted");
                setChildDeleteModal(false);
                setLoading(false);
                GetFamilyList();
                if (ChildIsParent == true) {
                    history('/Management');
                }
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/User/DeleteUserOrFamily",
                "errorNumber": "DC01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "DeleteChildUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }


    const SelectPrimaryUser = async (item) => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "familyGroupId": data[0]?.familyGroupId,
            "userMappingId": item?.userMappingId,
            "isParent": true,
            "modifiedUserId": myUserData?.userId.toString()
        };
        try {
            setLoading(true);
            console.log("body", bodyData);
            let response = await commonAPI("ResetPrimaryUser", bodyData)
            setLoading(true);
            console.log("SelectPrimaryUser", response);
            if (response.success == true && response.message.length == 0) {
                toast.success("Primary User Changed");
                setLoading(false);
                GetFamilyList();
                GetParentList();
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }


        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/User/ResetPrimaryUser",
                "errorNumber": "PU01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "SelectPrimaryUser",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }



    }




    const GetFuelList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            let response = await commonAPI("VehicleFuelType")
            setLoading(true);
            if (response?.success == true) {
                console.log("setFuelList", response)
                setFuelList(response.data);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);

            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Common/VehicleFuelType",
                "errorNumber": "FL01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "GetFuelList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const GetBrandList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            let response = await commonAPI("VehicleBrand")
            setLoading(true);
            if (response?.success == true) {
                console.log("setBrand", response)
                const tempData = response?.data.filter((item) => item?.vehicleType.toUpperCase() == VehicleType)
                setBrandList(tempData);
                setBrandListUpdate(tempData);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);

            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Common/VehicleBrand",
                "errorNumber": "BL01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "GetBrandList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    // const GetVehicleResident = async () => {
    //     const auth = localStorage.getItem("userData");
    //     const myUserData = JSON.parse(auth);
    //     try {
    //         let response = await commonAPI("ResidentVehicleList")
    //         setLoading(true);
    //         if (response?.success== true){
    //             console.log("setFuelList", response)
    //             setVehicleListGet(response.data);
    //             setLoading(false);
    //         }else{
    //             setLoading(false);
    //             toast.error("Something went wrong");
    //         }

    //     } catch (error) {
    //         console.log(error);
    //         setLoading(false);

    //         const bodyError = { 
    //             "userId": myUserData?.userId,
    //             "mobileNumber": myUserData?.mobileNumber,
    //             "requestJSON": null,
    //             "uri": "/api/Vehicle/ResidentVehicle",
    //             "errorNumber": "VL01",
    //             "errorSource": ErrorSource,
    //             "errorSummary": error.message,
    //             "errorDescription": error.message,
    //             "fileClassName": "Familydetails.js",
    //             "functionName": "GetVehicleResident",
    //         };
    //         let response = await commonAPI("ErrorLogMaster", bodyError);
    //         console.log("statusCode", response);
    //         if (response.success == true && response.message.length == 0) {
    //             toast.error("Something went wrong");
    //             setLoading(false);
    //         } else {
    //             setLoading(false);
    //             toast.error("Something went wrong");
    //         }
    //     }

    // }

    useEffect(() => {
        GetBrandList();
    }, [VehicleType, showBrand])

    useEffect(() => {
        GetFuelList();
        GetBrandList();
        GetAppSettings();
    }, [])

    const AddVehicle = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "createdUserId": myUserData?.userId?.toString(),
            "familyGroupId": data[0]?.familyGroupId,
            "flatId": data[0]?.item?.flatId,
            "gateAccessFactor": 11,
            "lpNumber": VehicleNumber?.toUpperCase().replaceAll(" ", ""),
            "fuelType": FuelType ? FuelType : null,
            "brand": BrandSelect ? BrandSelect : null,
            "ownerName": data[0]?.userName,
            "securityLock": false,
            "tagId": TagIdShow?.toString(),
            "tagSerialNumber": TagSerialNumberDisplay ? TagSerialNumberDisplay : null ,
            "vehicleType": VehicleType
        };
        try {
            if (!VehicleNumber) {
                toast.warning("Please enter Vehicle Number");
                setLoading(false);
            // }  else if (!FuelType) {
            //     toast.warning("Please select Fuel Type");
            //     setLoading(false);
            // } else if (!BrandSelect) {
            //     toast.warning("Please select Brand");
            //     setLoading(false);
            } else if (!VehicleType) {
                toast.warning("Please select Vehicle Type");
                setLoading(false);
            } else {
                console.log("bodyData", bodyData)
                setLoading(true);
                const endPointVariableKey = {
                    buildingId: myUserData.buildingId
                }
                let response = await commonAPI("ResidentVehicleAdd", bodyData, endPointVariableKey);
                console.log("bodyDataresponse", response)
                if (response.success == true && response.message.length == 0) {
                    toast.success("Vehicle Added");
                    GetVehicleList();
                    RFIDTagList();
                    setLoading(false);
                    setShowVehicle(false)
                } else {
                    toast.error(response.message[0]);
                    setLoading(false);
                }
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/ResidentVehicle",
                "errorNumber": "AV01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "AddVehicle",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    }

    const UpdateVehicle = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "familyGroupId": FamilyGroupId,
            "flatId": FlatId,
            "gateAccessFactor": 11,
            "lpNumber": VehicleNumber?.toUpperCase().replaceAll(" ", ""),
            "fuelType": FuelType ? FuelType : null,
            "ownerName": OwnerName,
            "securityLock": SecurityLock,
            "tagId": TagIdShow?.toString(),
            "tagSerialNumber": TagSerialNumberDisplay ? TagSerialNumberDisplay : null ,
            "vehicleType": VehicleType,
            "vehicleId": VehicleId,
            "modifiedUserId": myUserData?.userId?.toString(),
            "brand": BrandSelect ? BrandSelect : null,
        };
        try {
            if (!VehicleNumber) {
                toast.warning("Please enter Vehicle Number");
                setLoading(false);
            // }  else if (!FuelType) {
            //     toast.warning("Please select Fuel Type");
            //     setLoading(false);
            // } else if (!BrandSelect) {
            //     toast.warning("Please select Brand");
            //     setLoading(false);
            } else if (!VehicleType) {
                toast.warning("Please select Vehicle Type");
                setLoading(false);
            } else {
                console.log("bodyData", bodyData)
                setLoading(true);
                const endPointVariableKey = {
                    buildingId: myUserData.buildingId
                }
                let response = await commonAPI("ResidentVehicleUpdate", bodyData, endPointVariableKey);
                console.log("bodyDataresponse", response)
                if (response.success == true && response.message.length == 0) {
                    toast.success("Vehicle Updated");
                    GetVehicleList();
                    RFIDTagList();
                    setLoading(false);
                    setShowVehicle(false)
                } else {
                    toast.error(response.message[0]);
                    setLoading(false);
                }
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/ResidentVehicle",
                "errorNumber": "AV01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "AddVehicle",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    }

    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setVehicleId(item?.vehicleId)

    }

    const DeleteVehicle = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            "vehicleId": VehicleId,
            "modifiedUserId": myUserData.userId.toString()
        };
        try {
            console.log("bodyData", bodyData)
            setLoading(true);
            const endPointVariableKey = {
                buildingId: myUserData.buildingId
            }
            let response = await commonAPI("ResidentVehicleDelete", bodyData, endPointVariableKey);
            console.log("bodyDataresponse", response)
            if (response.success == true && response.message.length == 0) {
                toast.success("Delete Vehicle");
                GetVehicleList();
                RFIDTagList();
                setLoading(false);
                setDeleteShow(false)
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Vehicle/ResidentVehicle",
                "errorNumber": "AV01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "DeleteVehicle",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    }

    const VehicleCar = async () => {
        setVehicleTypeBtnCar(true)
        setVehicleTypeBtnBike(false)
        setVehicleType("4WHEELER")
    }

    const VehicleBike = async () => {
        setVehicleTypeBtnCar(false)
        setVehicleTypeBtnBike(true)
        setVehicleType("2WHEELER")
    }

    const BarndNameSelected = async (item) => {
        console.log("brand Name Selected", item)
        setBrandSelect(item?.brandName)
        setShowBrand(false)
    }

    function filterData(text) {
        setSearchBrand(text)
        //console.log(filterImg)
        const oldData = BrandList
        // console.log(oldLogo,"LOGO")
        console.log(text.toLowerCase())
        const newLogo = BrandListUpdate?.filter((BrandList) => {
            return BrandList?.brandName?.toLowerCase()?.includes(text.toLowerCase())
        })
        // console.log(newLogo)
        setBrandList(newLogo)
        // console.log(logo)
    }

    const searchSerial = (value) => {
        console.log(value, "VALUE");
        console.log(filterRfId);
        const filterDataRF = filterRfId?.filter((tagId) => {
            return String(tagId?.tagSerialNumber).includes(value);
        });
        setRFIDTagData(filterDataRF);
    }

    const searchUserSerial = (value) => {
        console.log(value, "VALUE");
        console.log(filterRfId);
        const filterDataRF = SearchUserTagList?.filter((tagId) => {
            return String(tagId?.tagSerialNumber).includes(value);
        });
        setUserTagList(filterDataRF);
    }

    const myFunctionRestfilter = ()=>{
        setRFIDTagData(filterRfId)
    }

   
    const GetAppSettings = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            const endPointVariableKey = {
                buildingId: myUserData?.buildingId
            };
            let response = await commonAPI("AppSettings", undefined, endPointVariableKey);
            console.log("AppSettings response", response);
            if (response?.success === true && response?.message.length === 0) {
                const filteredSettings = response?.data?.filter(setting => 
                    setting?.key === "FETCH_FASTAG_FROM_NPCI_API_ENDPOINT" || 
                    setting?.key === "ALLOW_RESIDENT_VEHICLE_FASTAG_MAPPING"
                );

                const fastagSetting = filteredSettings?.find(setting => setting?.key === "FETCH_FASTAG_FROM_NPCI_API_ENDPOINT");
                const residentFastagSetting = filteredSettings?.find(setting => setting?.key === "ALLOW_RESIDENT_VEHICLE_FASTAG_MAPPING");

                if (fastagSetting) {
                    setFastagEndPoint(fastagSetting?.value);
                }

                if (residentFastagSetting) {
                    setResidentFastagSetting(residentFastagSetting?.value);
                }
                console.log("App Settings Data:", fastagSetting?.value, residentFastagSetting?.value);
            } else {
                toast.error(response?.message[0]);
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/AppSettings",
                "errorNumber": "AS01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "GetAppSettings",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("ErrorLogMaster response", response);
            toast.error("Something went wrong while fetching app settings");
        }
    };

    const mapFastag = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            setLoading(true);
            if (!VehicleNumber) {
                toast.warning("Please enter Vehicle Number");
                setLoading(false);
                return;
            }
            // if (!VehicleId) {
            //     toast.warning("Vehicle ID is missing");
            //     setLoading(false);
            //     return;
            // }
            const bodyData = {
                lpNumber: VehicleNumber,
                vehicleId: VehicleId,
                modifiedUserId: myUserData?.userId?.toString()
            };
            const endPointVariableKey = {
                buildingId: myUserData?.buildingId
            };
            console.log("MapFastag bodyData", bodyData);
            const response = await commonAPI("MapFasTag", bodyData, endPointVariableKey);
            console.log("MapFastag response", response);
            if (response?.success === true && response?.message.length === 0) {
                toast.success("Fastag mapped successfully");
                setLoading(false);
                // Process the response data as needed
                console.log("Mapped Fastag Data:", response?.data);
            } else {
                toast.error(response?.message[0]);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Vehicle/MapFastag",
                "errorNumber": "MF01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Familydetails.js",
                "functionName": "mapFastag",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("ErrorLogMaster response", response);
            toast.error("Something went wrong while mapping Fastag");
        }
    };

    const [key, setKey] = useState('Family-Details');

    useEffect(()=>{
        console.log(data[0],"DATATATA")
        setKeyForReturn(data[0])
    },[])

    return (
        <>
             
                {Loading ?
                    <div className="loaderDiv">
                        <div className="loader"></div>
                    </div>
                    : null}
                <Menus />
            {/* <Online>      */}
                <ToastContainer />
                <section id="client-builder">
                    <div className="container-fluid pt-4">
                        <div className="row page-titles">
                            <div className="col-md-12 align-self-end text-right">
                                <Link to={"/Management"} state={{ "item": "Hello"  }}>
                                    <FontAwesomeIcon icon={faChevronLeft} className='bck' />
                                    <span> Back</span> </Link>
                            </div>
                        </div>
                        <Modal centered show={DeleteShow} onHide={() =>
                            setDeleteShow(false)}  dialogclassName="modal-100w " aria-labelledby="contained-modal-title-vcenter ">
                            <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                                <div className="row px-3" id="validation">
                                    <div className="col-12 bg-white pt-3 pb-2">
                                        <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                            <div className="FnFtxt">
                                                <h2> Delete Vehicle </h2>
                                                <h3> Are you sure you want to delete? </h3>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                    <div className='both_ConfrmBTN col-6' onClick={DeleteVehicle}>
                                        <Button variant="danger">Delete</Button>{' '}
                                    </div>
                                    <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                                        <Button variant="light"> Cancel</Button>{' '}
                                    </div>
                                </div>
                            </Modal.Body>

                        </Modal>
                        <Modal centered show={ChildDeleteModal} onHide={() =>
                            setChildDeleteModal(false)}  dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                            <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                                <div className="row px-3" id="validation">
                                    <div className="col-12 bg-white pt-3 pb-2">
                                        <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                            <div className="FnFtxt">
                                                <h2> Delete Family Member </h2>
                                                <h3> Are you sure you want to delete? </h3>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                    <div className='both_ConfrmBTN col-6' onClick={DeleteChildUser}>
                                        <Button variant="danger">Delete</Button>{' '}
                                    </div>
                                    <div className='both_ConfrmBTN col-6' onClick={() => setChildDeleteModal(false)} >
                                        <Button variant="light"> Cancel</Button>{' '}
                                    </div>
                                </div>
                            </Modal.Body>

                        </Modal>

                        <Modal show={show} onHide={() =>
                            setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                            <Modal.Header closeButton className='headerMDL'>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    Family Details
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                
                                    <div className="row" id="validation">
                                        <div className="col-md-12 mb-2">
                                            <div className="form-group text-left mt-2">
                                                <label for="wfirstName2"> Name  <span className="danger">*</span> </label>
                                                <input type="text" value={UserName} onChange={(e) => setUserName(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" /> </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-2">
                                                <label for="wlastName2"> Mobile Number  <span className="danger">*</span> </label>
                                                <input type="text" value={MobileNumber} onChange={(e) => setMobileNumber(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true"  disabled={EditFamily}/>
                                            </div>

                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-2">
                                                <label for="wlastName2"> Email </label>
                                                <input type="text" value={Email} onChange={(e) => setEmail(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" disabled={EditFamily}/>
                                            </div>

                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-2">
                                                <label for="wlastName2"> Tag Id </label>
                                                <div onClick={() => setUserTagIdModal(true)}>
                                                    <input type="text" value={TagSerialNumberDisplay} placeholder='Select Tag'  onClick={()=>{setUserTagIdModal(true);myFunctionRestfilter()}} onChange={(e) => setTagId(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" readOnly/>
                                                </div>    
                                            </div>

                                        </div>
                                         <div className="col-md-12">
                                            <div className="form-group text-left mt-2">
                                                <label htmlFor="gender">Gender <span className="danger">*</span></label><br />
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <input type="radio" id="Male" name="gender" value="Male" checked={Gender === "Male"} onChange={() => setGender("Male")} />
                                                    <label htmlFor="Male">Male</label><br />
                                                    <input type="radio" id="Female" name="gender" value="Female" checked={Gender === "Female"} onChange={() => setGender("Female")} />
                                                    <label htmlFor="Female">Female</label><br />
                                                    <input type="radio" id="Other" name="gender" value="Other" checked={Gender === "Other"} onChange={() => setGender("Other")} />
                                                    <label htmlFor="Other">Other</label><br />
                                                </div>
                                                {/* <input type="radio"  name="fav_language" value="Tenant" />
                                            <label for="javascript">JavaScript</label> */}

                                            </div>
                                        </div>
                                    
                                    </div>
                                
                             
                            </Modal.Body>

                            
                            <div class="fixed_allbtn">
                                        <div class="upload_btn">
                                        
                                        
                                            <div class="  align-self-start">
                                                
                                            {!ChildUpdate ?
                                            <div className="  text-left mt-3">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => ChildUser()}> Submit</button>
                                            </div>
                                            : null
                                        }
                                        {ChildUpdate ?
                                            <div className="  text-left mt-3">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => UpdateChildUser()}> Update</button>
                                            </div>
                                            : null
                                        }
                                                
                                                </div>
                                            
                                            
                                                </div>
                                                </div>


                        </Modal>

                        <Modal show={showBrand} onHide={() =>
                            [setShowBrand(false), setSearchBrand("")]} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
                            <Modal.Header closeButton className='headerMDL w-100'>
                                <Modal.Title id="example-custom-modal-styling-title w-100">
                                    Select Vehicle Brand
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className='w-100'>
                                
                                    <div className="row" id="validation">

                                        <div className="col-lg-7 offset-md-5 mb-2 text-center">
                                            <div className="form-group text-left mt-2">
                                                {/* <label for="wfirstName2"> Vehicle Number  </label> */}
                                                <input type="text" value={SearchBrand} placeholder='Search Vehicle Brand' onChange={(e) => filterData(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" /> </div>
                                        </div>
                                        
                                            <div className="selectVehicleBrand" style={{width: 500}}>
                                            {BrandList ? BrandList.map((item, index) => <button key={index} className='col-4 text-center m-0' value={item?.brandName} onClick={(e) => BarndNameSelected(item)}>
                                                <img className="card-img" style={{ width: "100%", height: 100, border: "1px solid #dadada", borderRadius: 10, padding: 5 }} src={"data:image/png;base64," + (item?.logo)} alt="Card image" />
                                                <h6 className='mt-2 text-black'>{item?.brandName}</h6>
                                            </button>) : null}
                                            </div>

                                    
                                        {/* {ShowUpdateBtn ?
                                        <div className="  text-left mt-3">
                                            <button type="button" className="btn border bg-white" onClick={() => setShowBrand(false)}> Cancel</button>
                                            <button type="button" className="btn btn-info" onClick={() => UpdateVehicle()}> Update</button>
                                        </div>:
                                        <div className="  text-left mt-3">
                                            <button type="button" className="btn border bg-white" onClick={() => setShowBrand(false)}> Cancel</button>
                                            <button type="button" className="btn btn-info" onClick={() => AddVehicle()}> Submit</button>
                                        </div>
                                    } */}

                                    </div>
                        
                            </Modal.Body>

                            
                        </Modal>

                        <Modal show={tagId} onHide={() =>
                            setTagIdModal(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
                            <Modal.Header closeButton className='headerMDL'>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    RFID Tags
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                
                                    <div className="row" id="validation">

                                    
                                        <input type="number" placeholder="Search by serial #" className="form-control required col-6 mr-3 ml-auto" onChange={(e)=>{searchSerial(e.target.value)}}></input>
                                        <div className="tableFixHead">

                                            <Table bordered hover className="mb-0 mt-3 ml-3 rfid_table  table-responsive">
                                            
                                            <thead>
                                                <tr>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '15%'}}>Lot #</th>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '30%'}}>Serial #</th>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '50%'}}>Tag ID</th>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '10%'}}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {rfTagIdList
                                                ? rfTagIdList.map((item, index) => (                
                                                <tr key={index}>
                                                    <td className="ln" style={{width:"15%"}}> {item?.lotNumber} </td>
                                                    <td style={{width:"25%"}} className="sn"> {item?.tagSerialNumber} </td>
                                                    <td style={{width:"25%",textAlign:'left'}}> {item?.tagId}</td>
                                                    <td style={{width:"10%",textAlign:'left', padding: 0}}> <button className='text-primary p-1' onClick={()=>{setTagSerialNumberDisplay(item?.tagSerialNumber); setTagIdShow(item?.tagIdHidden); setTagIdModal(false)}} variant="primary" > Select</button></td>
                                                </tr>)
                                            ):null}
                                            </tbody>
                                        
                                            {/* <tfoot>
                                                <tr>
                                                    <th><input type="number" value={LotNumber} onChange={(e) => setLotNumber(e.target.value)} placeholder="Lot Number" className="footbtn" /></th>
                                                    <th><input type="number" value={Serialnumber} onChange={(e) => setSerialnumber(e.target.value)} placeholder="Serial Number" className="footbtn"  /></th>
                                                    <th><input type="text" value={TagId} onChange={(e) => setTagId(e.target.value)} placeholder="Tag ID" className="footbtn"  /></th>
                                                    <th>
                                                        <select name="cars" className="footbtn" disabled={IsIssuedDisable} value={IsIssued} onChange={(e) => setIsIssued(e.target.value)}>
                                                            <option value={true}>Yes</option>
                                                            <option value={false}>No</option>
                                                        </select>
                                                    </th>
                                                
                                                </tr>
                                            </tfoot> */}
                                        </Table>
                                        </div>   
                                        

                                        {/* {ShowUpdateBtn ?
                                        <div className="  text-left mt-3">
                                            <button type="button" className="btn border bg-white" onClick={() => setShowBrand(false)}> Cancel</button>
                                            <button type="button" className="btn btn-info" onClick={() => UpdateVehicle()}> Update</button>
                                        </div>:
                                        <div className="  text-left mt-3">
                                            <button type="button" className="btn border bg-white" onClick={() => setShowBrand(false)}> Cancel</button>
                                            <button type="button" className="btn btn-info" onClick={() => AddVehicle()}> Submit</button>
                                        </div>
                                    } */}

                                    </div>
                        
                            </Modal.Body>

                            
                        </Modal>

                        <Modal show={usertagModal} onHide={() =>
                            setUserTagModal(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
                            <Modal.Header closeButton className='headerMDL'>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    Map Tag
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                
                                    <div className="row" id="validation">
                                    <div className="col-md-12">
                                        <div className="form-group text-left mt-2">
                                            <label for="wlastName2"> Tag Id </label>
                                            <div onClick={() => {setUserTagIdModal(true); setIsMappedTag(false) }}>
                                                <input type="text" value={UserTagId} placeholder='Select Tag'  onClick={()=>{setUserTagIdModal(true);myFunctionRestfilter()}} onChange={(e) => setUserTagId(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" readOnly/>
                                            </div>    
                                        </div>

                                    </div>
                                    <div className="col-md-12 mb-2" style={{visibility: "hidden"}}>
                                            <div className="form-group text-left mt-2">
                                                <label for="wfirstName2"> Name  <span className="danger">*</span> </label>
                                                <input type="text" value={UserName} onChange={(e) => setUserName(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" /> </div>
                                        </div>
                                        <div className="col-md-12" style={{visibility: "hidden"}}>
                                            <div className="form-group text-left mt-2">
                                                <label for="wlastName2"> Mobile Number  <span className="danger">*</span> </label>
                                                <input type="text" value={MobileNumber} onChange={(e) => setMobileNumber(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                            </div>

                                        </div>
                                        
                                    
                                    </div>
                                
                             
                            </Modal.Body>

                            
                            <div class="fixed_allbtn">
                                        <div class="upload_btn">
                                        
                                        
                                            <div class="  align-self-start">
                                           
                                                <div className="  text-left mt-3">
                                                    <button type="button" className="btn border bg-white" onClick={() => setUserTagModal(false)}> Cancel</button>
                                                    <button type="button" className="btn btn-info" onClick={() => MapUserTag()}> Submit</button>
                                                </div>
                                           
                                                </div>
                                            
                                            
                                                </div>
                                                </div>


                        </Modal>

                        <Modal show={usertagId} onHide={() =>
                            setUserTagIdModal(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
                            <Modal.Header closeButton className='headerMDL'>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    User Tags
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                
                                    <div className="row" id="validation">

                                    
                                        <input type="number" placeholder="Search by serial #" className="form-control required col-6 mr-3 ml-auto" onChange={(e)=>{searchUserSerial(e.target.value)}}></input>
                                        <div className="tableFixHead">

                                            <Table bordered hover className="mb-0 mt-3 ml-3 rfid_table  table-responsive">
                                            
                                            <thead>
                                                <tr>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '15%'}}>Lot #</th>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '30%'}}>Serial #</th>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '30%'}}>Secret #</th>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '30%'}}>Tag ID</th>
                                                    <th style={{ padding:' 10px 5px 10px 5px', width: '10%'}}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {UserTagList
                                                ? UserTagList.map((item, index) => (                
                                                <tr key={index}>
                                                    <td className="ln" style={{width:"15%"}}> {item?.lotNumber} </td>
                                                    <td style={{width:"25%"}} className="sn"> {item?.tagSerialNumber} </td>
                                                    <td style={{width:"25%"}} className="sn"> {item?.secretCode} </td>
                                                    <td style={{width:"25%",textAlign:'left'}}> {item?.tagId}</td>
                                                    <td style={{width:"10%",textAlign:'left', padding: 0}}> <button className='text-primary p-1' onClick={()=>{setUserTagId(item?.tagSerialNumber); setSecretCode(item?.secretCode); setUserTagIdModal(false); setTagSerialNumberDisplay(item?.tagId)}} variant="primary" > Select</button></td>
                                                </tr>)
                                            ):null}
                                            </tbody>
                                        
                                            
                                        </Table>
                                        </div>   
                                        

                                      
                                    </div>
                        
                            </Modal.Body>

                            
                        </Modal>

                        <Modal show={showVehicle} onHide={() =>
                            setShowVehicle(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
                            <Modal.Header closeButton className='headerMDL'>
                                <Modal.Title id="example-custom-modal-styling-title">
                                {modalHeading}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{width:"500px"}}>
                                
                                    <div className="row" id="validation">
                                        <div className="col-md-12 mb-2 text-center">
                                            <div className='fam_vehicleBtn'>
                                                {VehicleTypeBtnCar ?
                                                    <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon bg-info text-white' />
                                                    :
                                                    <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon text-info border-info' />
                                                }
                                                {VehicleTypeBtnBike ?
                                                    <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon bg-info text-white' />
                                                    :
                                                    <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon text-info border-info' />


                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-2">
                                            <div className="form-group text-left mt-2">
                                                <label for="wfirstName2"> Vehicle Number  <span className="danger">*</span> </label>
                                                <input type="text" value={VehicleNumber} onChange={(e) => setVehicleNumber(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" /> </div>
                                        </div>
                                       
                                        <div className="col-md-12">
                                            {/* <a onClick={() => fetchFastagDetails()} rel="noopener noreferrer" style={{position: "absolute", right: "20px", top: "0px",}}>
                                                Fastag
                                            </a> */}
                                            <div className="form-group text-left mt-2">
                                                <label for="wlastName2"> Tag Id </label>
                                                <div onClick={() => setTagIdModal(true)}>
                                                    <input type="text" value={TagSerialNumberDisplay} placeholder='Select Tag'  onClick={()=>{setTagIdModal(true);myFunctionRestfilter()}} onChange={(e) => setTagId(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" readOnly/>
                                                </div>    
                                            </div>

                                        </div>
                                        {ShowResidentSetting == 1 ?
                                        <>
                                        {ShowUpdateBtn ?
                                            <div className="col-md-12">
                                                <div className="form-group text-left mt-2">
                                                    <label for="fastagStatus">Fastag Status</label>
                                                    <div className="d-flex align-items-center">
                                                        <input
                                                            type="text"
                                                            value={FastagMap}
                                                            className="form-control required"
                                                            id="fastagStatus"
                                                            name="fastagStatus"
                                                            aria-required="true"
                                                            readOnly
                                                        />
                                                            <button
                                                                type="button"
                                                                className="btn btn-link ml-2"
                                                                onClick={() => mapFastag()}
                                                            >
                                                                <FontAwesomeIcon icon={faTag} className="text-info" /> {FastagMap == "Not Mapped" ? "Map" : "Remap"}
                                                            </button>
                                                    </div>
                                                </div>
                                            </div>
                                            :null}
                                        </> : null}    
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-3">
                                                <label for="wlastName2"> Fuel Type </label><br />
                                                <select size="md" className="form-control required" value={FuelType} onChange={(e) => {
                                                    console.log("selection", e.target.value)
                                                    setFuelType(e.target.value);
                                                }}>
                                                    <option value={""}>Select Type</option>
                                                    {FuelList ? FuelList.map((item, index) => <option key={index} value={item?.fuelTypeName}>{item.fuelTypeName}</option>) : null}
                                                </select>
                                            </div>

                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-3">
                                                <label for="wlastName2"> Brand Type </label><br />
                                                <div onClick={() => setShowBrand(true)}>
                                                    <input type="text" value={BrandSelect} readOnly placeholder='Select Brand' className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    





                                
                            </Modal.Body>
                            <div class="fixed_allbtn">
                                        <div class="upload_btn">
                                        
                                        
                                            <div class="  align-self-start">
                                                
                                                {ShowUpdateBtn ?
                                                    <div className="  text-left mt-3">
                                                        <button type="button" className="btn border bg-white" onClick={() => setShowVehicle(false)}> Cancel</button>
                                                        <button type="button" className="btn btn-info" onClick={() => UpdateVehicle()}> Update</button>
                                                    </div> :
                                                    <div className="  text-left mt-3">
                                                        <button type="button" className="btn border bg-white" onClick={() => setShowVehicle(false)}> Cancel</button>
                                                        <button type="button" className="btn btn-info" onClick={() => AddVehicle()}> Submit</button>
                                                    </div>
                                                }
                                                
                                            </div>
                                            
                                            
                                        </div>
                                        </div>
                                        
                        </Modal>

                        {/* Edit Resident Modal */}
                        <Modal show={ResidentShow} onHide={() =>
                            setResidentShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
                            <Modal.Header closeButton className='headerMDL'>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    Family Details
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                
                                    <div className="row" id="validation">
                                        <div className="col-md-12 mb-2">
                                            <div className="form-group text-left mt-2">
                                                <label for="wfirstName2"> Name  <span className="danger">*</span> </label>
                                                <input type="text" value={UserName} onChange={(e) => setUserName(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" /> </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-2">
                                                <label for="wlastName2"> Mobile Number </label><br />
                                                <input type="text" value={MobileNumber} onChange={(e) => setMobileNumber(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                            </div>

                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-3">
                                                <label for="wlastName2"> Email   </label>
                                                <input type="text" value={Email} onChange={(e) => setEmail(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                            </div>

                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group text-left mt-2">
                                                <label htmlFor="gender">Gender <span className="danger">*</span></label><br />
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <input type="radio" id="Male" name="gender" value="Male" checked={Gender === "Male"} onChange={() => setGender("Male")} />
                                                    <label htmlFor="Male">Male</label><br />
                                                    <input type="radio" id="Female" name="gender" value="Female" checked={Gender === "Female"} onChange={() => setGender("Female")} />
                                                    <label htmlFor="Female">Female</label><br />
                                                    <input type="radio" id="Other" name="gender" value="Other" checked={Gender === "Other"} onChange={() => setGender("Other")} />
                                                    <label htmlFor="Other">Other</label><br />
                                                </div>
                                                {/* <input type="radio"  name="fav_language" value="Tenant" />
                                            <label for="javascript">JavaScript</label> */}

                                            </div>
                                        </div>
                                        
                                

                                    </div>
                            
                            </Modal.Body>   

                                                    <div class="fixed_allbtn">
                                        <div class="upload_btn">
                                        
                                        
                                            <div class="  align-self-start">
                                                
                                            <button type="button" className="btn border bg-white" onClick={() => setResidentShow(false)}> Cancel</button>
                                            <button type="button" className="btn btn-info" onClick={() => UpdateResidentUser()}> Update</button>
                                            </div>
                                            
                                            
                                        </div>
                                        </div>


                        </Modal>
                        <div className="row">
                            <div className="col-12">
                                <div className="mt-3">
                                    <div >
                                        {/* <h4 className="card-title">Family Details</h4> */}
                                        {/* 
                                    <h6 className="card-subtitle">Export details to Copy, CSV, Excel, PDF & Print</h6>
                                    */}
                                        <div className="m-t-20">
                                            <div id="example23_wrapper" className="dataTables_wrapper">
                                                <div className="row">
                                                    <div className="col-lg-3 col-xlg-3 col-md-5">

                                                        <div className="card">

                                                            <img className="card-img" src={socialbg} alt="Card image" />
                                                            <div className="card-img-overlay card-inverse social-profile">
                                                        
                                                                <div className="align-self-center pt-4">


                                                                    <div className='el-element-overlay'>
                                                                        <div className='el-card-item pb-0'>
                                                                            
                                                                            <div className='el-card-avatar el-overlay-1 mb-0' style={{ display: 'ruby-text' }}>
                                                                                {ParentList[0]?.userImage ?
                                                                                    <img src={ParentList[0]?.userImage} alt="user" style={{ width: '110px',height:'145px' }} />
                                                                                :
                                                                                    <>  
                                                                                        {ParentList[0]?.gender == "Male" ?
                                                                                            <img src={oldy} alt="user" style={{ width: '110px',height:'130px' }} />
                                                                                        : null}
                                                                                        {ParentList[0]?.gender == "Female" ?
                                                                                            <img src={FemaleImage} alt="user" style={{ width: '110px',height:'130px' }} />
                                                                                        : null}
                                                                                        {ParentList[0]?.gender == "Transgender" ?
                                                                                            <img src={TransgenderImage} alt="user" style={{ width: '110px',height:'130px' }} />
                                                                                        : null}
                                                                                        {ParentList[0]?.gender == "" ?
                                                                                            <img src={oldy} alt="user" style={{ width: '110px',height:'130px' }} />
                                                                                        : null}
                                                                                    </>
                                                                                }
                                                                                <div className="el-overlay scrl-dwn" style={{ width: "131px",top: "-35px",position: "absolute", left: "-10%", height: "111px" }}>
                                                                                    <ul className="el-info">
                                                                                        <li>
                                                                                            {myUserData?.roleName !== "Society Operator" ?
                                                                                            <>
                                                                                                <a className="btn default btn-outline image-popup-vertical-fit" >
                                                                                                    <FontAwesomeIcon icon={faEdit} onClick={() => UpdateChildModal2()} />
                                                                                                </a>
                                                                                                <a className="btn default btn-outline image-popup-vertical-fit ml-2 fam_del" >
                                                                                                    <FontAwesomeIcon icon={faTrash} onClick={() => DeleteParentModal()} />
                                                                                                </a>
                                                                                            </>
                                                                                            : null}
                                                                                            <a className="btn default btn-outline image-popup-vertical-fit mt-1" >
                                                                                                <FontAwesomeIcon icon={faTag} onClick={() => {
                                                                                                    setUserTagId(ParentList[0]?.tagSerialNumber);
                                                                                                    if (ParentList[0]?.tagSerialNumber) {
                                                                                                        setIsMappedTag(true);
                                                                                                    } else {
                                                                                                        setIsMappedTag(false);
                                                                                                    }
                                                                                                    UpdateTagModal(ParentList[0]);
                                                                                                }} />
                                                                                            </a>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>








                                                                    
                                                                        {/* <FontAwesomeIcon icon={faEdit} onClick={() =>
                                                                UpdateParentModal()} class="append_position"/> */}
                                                                     
                                                                    <h4 className="card-title">{ParentList[0]?.userName}</h4>
                                                                    
                                                                    <h6 className="card-subtitle text-white">
                                                                            {ParentList[0]?.emailId}
                                                                    </h6>
                                                                    
                                                                    
                                                                    <h6 className='text-white'>Phone : +91 {ParentList[0]?.mobileNumber}</h6>
                                                                    
                                                                    <h6 className='text-white'>Address : {ParentList[0]?.towerName} - {ParentList[0]?.flatName}</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-9 col-xlg-9 col-md-7">
                                                    <div className='relatetoMain'>
                                                        <div className="absolutetoMain">
                                                            <Link to="/Management"  state={{ item: "Hello"  }} >
                                                                <FontAwesomeIcon icon={faChevronLeft} style={{fontSize:"13px",marginRight:"5px"}}/>    <span> Back </span>
                                                            </Link>
                                                        </div>
                                                                                                                                                            
                                                                            </div>
                                                        <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) =>
                                                            setKey(k)} className="mb-3">
                                                            <Tab eventKey="Family-Details" title="Family Details">
                                                                <div className="row el-element-overlay">
                                                                    {FamilyList ? FamilyList.map((item, index) => <>
                                                                        {!item?.isParent ?
                                                                            <div className="col-lg-3 col-md-6 mb-3" key={index}>
                                                                                <div className="card famcard">
                                                                                    <div className="el-card-item pb-0">
                                                                                    {item?.currentStatus == "APPROVED" ? 
                                                                                        <small class="stat" style={{backgroundColor: "#378805"}}>{item?.currentStatus}</small>
                                                                                    :<small class="stat">{item?.currentStatus}</small>}    
                                                                                        <div className="el-card-avatar el-overlay-1" style={{textAlign: "-webkit-center"}}>
                                                                                            {item?.userImage ? <img src={item?.userImage} alt="user" style={{width: "144px", height:'160px'}} /> 
                                                                                            :
                                                                                                <>
                                                                                                    {item?.gender == "Male" ?
                                                                                                        <img src={clientlogo} alt="user" />
                                                                                                    : null}
                                                                                                    {item?.gender == "Female" ?
                                                                                                        <img src={FemaleIcon} alt="user" />
                                                                                                    : null}
                                                                                                    {item?.gender == "Transgender" ?
                                                                                                        <img src={TransgenderIcon} alt="user" />
                                                                                                    : null}
                                                                                                    {item?.gender == "" ?
                                                                                                        <img src={clientlogo} alt="user" />
                                                                                                    : null}
                                                                                                </> 
                                                                                            // <img src={clientlogo} alt="user" />
                                                                                            }
                                                                                            {/* <img src={clientlogo} alt="user" /> */}
                                                                                            <div className="el-overlay scrl-dwn">
                                                                                                <ul className="el-info">
                                                                                                    <li>
                                                                                                        {myUserData?.roleName !== "Society Operator" ? 
                                                                                                        <>
                                                                                                            <a className="btn default btn-outline image-popup-vertical-fit" >
                                                                                                                <FontAwesomeIcon icon={faEdit} onClick={() =>
                                                                                                                    UpdateChildModal(item)} />
                                                                                                            </a>
                                                                                                            <a className="btn default btn-outline image-popup-vertical-fit ml-2 fam_del" >
                                                                                                                <FontAwesomeIcon icon={faTrash} onClick={() =>
                                                                                                                    DeleteUserModal(item)} />
                                                                                                            </a>
                                                                                                        </>
                                                                                                         :null}   
                                                                                                        <a className="btn default btn-outline image-popup-vertical-fit ml-2" >
                                                                                                            <FontAwesomeIcon icon={faTag} onClick={() =>
                                                                                                                {UpdateTagModal(item)
                                                                                                                    if (item?.tagSerialNumber) {
                                                                                                                        setIsMappedTag(true);
                                                                                                                    } else {
                                                                                                                        setIsMappedTag(false);
                                                                                                                    }
                                                                                                                }} />
                                                                                                        </a>
                                                                                                    </li>
                                                                                                </ul>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="el-card-content">
                                                                                            <h3 className="box-title">{item?.userName}</h3>
                                                                                            <small>+91-{item?.mobileNumber}</small>
                                                                                            
                                                                                            <br />
                                                                                            <div className='setPrimaryDiv'>
                                                                                                {item?.currentStatus == "APPROVED" ?
                                                                                                    <div className='primaryButton' onClick={() => {setDeleteShowOne(true);setPrimaryInfo(item)}}>Set as Primary </div>
                                                                                                :null}    

                                                                                                {/* <label className="switch1 ml-1" >
                                                                                                <input type="checkbox" checked={item?.isParent} onClick={() => SelectPrimaryUser(item)} />
                                                                                                <span className="slider1 round1" key={index}></span>
                                                                                            </label> */}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <Modal centered show={DeleteShowOne} onHide={() =>
                                                                                        setDeleteShowOne(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                                                                                        {/* <Modal.Header className="headerMDL" closeButton>
                        <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                            <h4 className="mb-0"> Delete Tower </h4>
                        </Modal.Title>
                    </Modal.Header> */}
                                                                                        <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                                                                                            <div className="row px-3" id="validation">
                                                                                                <div className="col-12 bg-white pt-3 pb-2">
                                                                                                    <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                                                                                        {/* <div className="FnFimg">
                                    <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                                </div> */}
                                                                                                        <div className="FnFtxt">
                                                                                                            <h2> Set Primary  </h2>
                                                                                                            <h3> Are you sure you want to set as Primary? </h3>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                </div>

                                                                                            </div>
                                                                                            <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                                                                                <div className='both_ConfrmBTN col-6' onClick={() => {SelectPrimaryUser(primaryInfo);setDeleteShowOne(false)}}>
                                                                                                    <Button variant="danger">Change</Button>{' '}
                                                                                                </div>
                                                                                                <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShowOne(false)} >
                                                                                                    <Button variant="light"> Cancel</Button>{' '}
                                                                                                </div>
                                                                                            </div>
                                                                                        </Modal.Body>
                                                                                    </Modal>
                                                                                </div>
                                                                            </div>
                                                                            : null}

                                                                    </>) : null}
                                                                    {ParentList[0]?.isResiding == true ?
                                                                        <div className="col-lg-3 col-md-6">
                                                                            <div className="card famcard">
                                                                                <div className="el-card-item">
                                                                                    <div className="el-card-avatar el-overlay-1">
                                                                                        <img src={family} alt="user" />
                                                                                        <div className="el-overlay scrl-dwn">
                                                                                            <ul className="el-info">
                                                                                                <li>
                                                                                                    <a className="btn default btn-outline image-popup-vertical-fit" onClick={() => AddChildModal()}>
                                                                                                        <FontAwesomeIcon icon={faPlus} />
                                                                                                    </a>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="el-card-content">
                                                                                        <h3 className="box-title">Add Member</h3>
                                                                                        <br />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : null}

                                                                    {/* 
                                                                <div className="col-lg-3 col-md-6 fmyadd">
                                                                    <Link to="#">
                                                                    <div className='editfamilymmbr'>
                                                                        <FontAwesomeIcon icon={faPlus} className='plus_marg'/>
                                                                        <h4 className='bold'> Add Member</h4>
                                                                    </div>
                                                                    </Link>
                                                                </div>
                                                                */}
                                                                </div>
                                                            </Tab>
                                                            <Tab eventKey="Vehicle-Details" title="Vehicle Details">
                                                                <div className="row">
                                                                    <div className="row el-element-overlay">
                                                                        {VehicleList ? VehicleList.map((item, index) => <>
                                                                            {/* {item.currentStatus.toUpperCase() == "APPROVED" ?  */}
                                                                                <div className="col-lg-3 col-md-6 mb-3" key={index}>
                                                                                    <div className="card">
                                                                                        <div className="el-card-item">
                                                                                        {item?.currentStatus == "APPROVED" ?   
                                                                                            <small className='stat' style={{backgroundColor: "#378805"}}>
                                                                                                    {/* {item?.brand} */}
                                                                                                    {item?.currentStatus}
                                                                                            </small>
                                                                                        :
                                                                                        <small className='stat'>
                                                                                                {item?.currentStatus}
                                                                                        </small>
                                                                                        }    
                                                                                            <div className="el-card-avatar el-overlay-1">
                                                                                                {item?.vehicleType == "4WHEELER" ?
                                                                                                    <img src={car} alt="user" />
                                                                                                    :
                                                                                                    <img src={Bike} alt="user" />
                                                                                                }
                                                                                                {/* <img src={car} alt="user" />
                                                                                        <img src={Bike} alt="user" /> */}
                                                                                                <div className="el-overlay scrl-dwn">
                                                                                                    <ul className="el-info">
                                                                                                        <li>
                                                                                                            <a className="btn default btn-outline image-popup-vertical-fit" >
                                                                                                                <FontAwesomeIcon icon={faEdit} onClick={() =>
                                                                                                                    setInputValue(item)} />
                                                                                                            </a>
                                                                                                            <a className="btn default btn-outline image-popup-vertical-fit ml-3 fam_del" >
                                                                                                                <FontAwesomeIcon icon={faTrash} onClick={() =>
                                                                                                                    ShowDeleteModal(item)} />
                                                                                                            </a>
                                                                                                        </li>
                                                                                                        {/* 
                                                                                                <li><a className="btn default btn-outline" href="javascript:void(0);"><i className="sl-icon-link"></i></a></li>
                                                                                                */}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="el-card-content">
                                                                                                <h3 className="box-title w-auto">{item?.lpNumber}</h3>

                                                                                                {/* <h5>{item?.currentStatus}</h5> */}
                                                                                                
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            {/* :null} */}
                                                                        </>) : null}
                                                                        {/* <div className="col-lg-3 col-md-6">
                                                                        <div className="card">
                                                                            <div className="el-card-item">
                                                                                <div className="el-card-avatar el-overlay-1">
                                                                                    <img src={Bike} alt="user" />
                                                                                    <div className="el-overlay scrl-dwn">
                                                                                        <ul className="el-info">
                                                                                            <li>
                                                                                                <a className="btn default btn-outline image-popup-vertical-fit">
                                                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                                                </a>
                                                                                            </li>
                                                                                            
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="el-card-content">
                                                                                    <h3 className="box-title">UP16SSD6758</h3>
                                                                                    <small>
                                                                                    Suzuki Gixxer 
                                                                                    </small>
                                                                                    <br/>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                                                        {ParentList[0]?.isResiding == true ?
                                                                            <div className="col-lg-3 col-md-6">
                                                                                <div className="card">
                                                                                    <div className="el-card-item">
                                                                                        <div className="el-card-avatar el-overlay-1">
                                                                                            <img src={cbadd} alt="user" />
                                                                                            <div className="el-overlay scrl-dwn">
                                                                                                <ul className="el-info">
                                                                                                    <li>
                                                                                                        <a className="btn default btn-outline image-popup-vertical-fit" >
                                                                                                            <FontAwesomeIcon icon={faPlus} onClick={() =>
                                                                                                                openCreateModal()} />
                                                                                                        </a>
                                                                                                    </li>
                                                                                                    {/* 
                                                                                            <li><a className="btn default btn-outline" href="javascript:void(0);"><i className="sl-icon-link"></i></a></li>
                                                                                            */}
                                                                                                </ul>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="el-card-content">
                                                                                            <h3 className="box-title">Add Vehicle</h3>
                                                                                
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            : null}
                                                                    </div>
                                                                </div>
                                                            </Tab>
                                                        </Tabs>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            {/* </Online>    
            <div style={{margin: 100, marginTop: -30}}>
                <Offline>
                    <NoInternet /> 
                </Offline>
            </div>  */}
        </>)

}
export default Familydetails